<template>
    <section class="main-content">
      <div class="page-width">
        <p class="lead-txt"><b>今ある借金は減額できる</b>かもしれません。<br>
        忙しくて時間がないという方でも、<br>
        <span>LINEをきっかけに完済している方が数多くいます！</span></p>
        <div class="btn-area">
          <a href="https://liff.line.me/2008396272-QvayAVwo/landing?follow=%40328thvah&lp=t8EOhY&liff_id=2008396272-QvayAVwo" data-cats="lineFriendsFollowLink">
            <img src="@/assets/simulator_button.gif" alt="LINE無料診断を試す">
          </a>
        </div>
      </div>
      <div class="voice">
        <h2>診断をきっかけに減額した方の声</h2>
        <swiper
        class="slider"
        :speed="1000"
        :autoplay="true"
        :modules="modules"
        :space-between="-10"
        :slides-per-view="slickNumber"
        :loop="true"
        :slidesPerView=1.1
        :centered-slides="true"
        :navigation="false">
          <swiper-slide>
            <div class="popup-display">
                <img src="@/assets/voice01.webp" alt="診断をきっかけに減額した方の声1">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="popup-display">
                <img src="@/assets/voice02.webp" alt="診断をきっかけに減額した方の声2">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="popup-display">
                <img src="@/assets/voice03.webp" alt="診断をきっかけに減額した方の声3">
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <div class="page-width btn-area">
        <a href="https://liff.line.me/2008396272-QvayAVwo/landing?follow=%40328thvah&lp=t8EOhY&liff_id=2008396272-QvayAVwo" data-cats="lineFriendsFollowLink">
          <img src="@/assets/simulator_button.gif" alt="LINE無料診断を試す">
        </a>
      </div>

      <div class="step">
        <div class="page-width">
            <p>LINEでの診断方法</p>
            <h2>簡単!!<b>3</b>STEP</h2>
            <img src="@/assets/step01.webp" alt="まずはボタンをタップ！">
            <img src="@/assets/step02.webp" alt="タップで友だち追加！">
            <img src="@/assets/step03.webp" alt="LINE診断スタート！">
        </div>
      </div>

      <div class="page-width btn-area">
        <figure>
          <figcaption>たった<span>1分</span>で<span>簡単に無料診断</span><br>
        法律のプロに相談も可能</figcaption>
        <img src="@/assets/woman.webp" alt="女性イラスト">

        </figure>
        <a href="https://liff.line.me/2008396272-QvayAVwo/landing?follow=%40328thvah&lp=t8EOhY&liff_id=2008396272-QvayAVwo" data-cats="lineFriendsFollowLink">
          <img src="@/assets/simulator_button.gif" alt="LINE無料診断を試す">
        </a>
      </div>


    </section>
  </template>
  
  <script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import { Autoplay, Navigation } from 'swiper'
  import 'swiper/css'
  import 'swiper/css/navigation'
  export default {
    name: 'MainContent',
    setup() {
    return {
      modules: [Navigation, Autoplay]
    }
  },
    computed: {
      slickNumber: function() {
        let windowWidth = window.innerWidth;
        if( windowWidth > 1000 ) {

          return ( window.innerWidth - 100 ) / 380
        }
        else {
          if( windowWidth > 480 ) {
            return 3;
          }
          else {
            return window.innerWidth / 240
          }
        }
      }
    },
    components: {
      Swiper,
      SwiperSlide
    }
  }
  </script>
  
<style scoped lang="scss">
@import "~@/Resources/styles.scss";

  .lead-txt {
    text-align: left;
    margin-bottom: 30px;
    margin-top: 15px;
    font-size: 16px;
      b {
      color: #F60144;
    }
    span {
      text-decoration: underline;
      font-weight: bold;
    }
  }

  .voice {
    padding: 20px 0;
    background: #F2F2F2;
    h2 {
      color: #4D9482;
    }
  }

  .btn-area {
    margin: 30px auto;
    figure {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40%;
        margin-bottom: -30px;
      }
      figcaption {
        width: 60%;
        text-align: left;
        span {
          font-weight: bold;
          color: #06C755;
        }
      }
    }
  }

  .step {
    background: #FFFCE8;
    padding: 20px 0;
    p {
      color: #06C755;
      font-weight: bold;
      font-size: 24px;
      margin-bottom: -15px;
      display: inline-block;
      border-left: 8px solid;
      border-right: 8px solid;
      padding-left: 15px;
      padding-right: 15px;
      line-height: 1em;
      transform: translateY(10px);
    }
    h2 {
      color: #06C755;
      font-size: 38px;
      margin-bottom: 20px;
      letter-spacing: 3px;
      b {
        font-size: 45px;
      }
    }
    img {
      margin-bottom: 20px;
    }
  }
</style>
  